import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "../lib/analytics";

// Renders nothing; reports a GA4 page_view whenever the route changes.
// Must live inside the Router so useLocation() has a router context.
const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => {
    const page = `${pathname}${search}`;
    // StrictMode runs effects twice in development; only report once per page.
    if (lastTracked.current === page) return;
    lastTracked.current = page;
    trackPageView();
  }, [pathname, search]);

  return null;
};

export default AnalyticsTracker;
